export default __webpack_public_path__ + "static/media/24px.6fc3a2e9.svg";